import React from "react";

const TerminosLegalCampaniaMicroText = () => {
  return (
    <>
      <p>
        <strong>
          CAMPAÑA MICRO (PREFERENTE – AMPLIADO) (CRÉDITO PRE APROBADO)
        </strong>
      </p>
      <p>
        <strong>Crédito sujeto a evaluación crediticia.</strong> Este producto
        está dirigido al cliente que está en la base de datos de Prymera, quien
        previamente ha sido evaluado según su Score y se le otorgó la{" "}
        <strong>condición de crédito pre-aprobado</strong>, para confirmar la
        aprobación de dicho crédito según considere Prymera, deberá entregar la
        documentación que se le solicite por los medios que se le indique. Es
        condición básica que el cliente mantenga la misma calificación
        crediticia de la presente Campaña al momento del desembolso, en caso
        contrario, deberá pasar una nueva evaluación crediticia.
      </p>
      <p>
        Ejemplo explicativo para crédito micro y pequeña empresa: TCEA
        referencial 40.21% considerando una TEA de 38.0%, por un monto de
        crédito de S/. 1,000.00 a 12 cuotas. Incluye el total de intereses de
        S/. 189.00 y gastos de seguro de desgravamen de 0.138% del saldo
        insoluto o residual. Base 360 días.
      </p>
      <p>
        Para mayor información sobre esta promoción, tasas de Interés,
        comisiones, gastos, términos y condiciones, consulte nuestro tarifario
        ubicado en nuestras oficinas o ingrese a: www.prymera.pe. Información
        brindada de conformidad con la ley N° 28587, Resolución SBS-3274-2017 y
        modificatorias. Operaciones afectas al ITF (0.005%).
      </p>
    </>
  );
};

export default TerminosLegalCampaniaMicroText;
